export const UC_OPTIONS = [
	{ label: "Unidade 1", value: "UNIDADE_1" },
	{ label: "Unidade 2", value: "UNIDADE_2" },
	{ label: "Unidade 3", value: "UNIDADE_3" },
];
